import { render, staticRenderFns } from "./StudentInformationTab.vue?vue&type=template&id=46ec3136&"
import script from "./StudentInformationTab.vue?vue&type=script&lang=js&"
export * from "./StudentInformationTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports